import { connectFela } from '../../dependencies';
import VatNumberField from './VatNumberField';
import * as styles from './VatNumberField.styles';

export default connectFela(styles)(VatNumberField);
